
import {
  defineComponent,
  reactive,
  toRefs,
  watchEffect,
  onMounted,
  ref,
} from 'vue'
import { required } from '@/utils/rules'
import { editDisposeStatus } from './api'
import { ElMessage } from 'element-plus'
import { toResult } from '@/utils/toResult'

export default defineComponent({
  components: {},
  props: {
    modelValue: {
      type: Boolean,
      required: true,
      default: false,
    },
    row: {
      type: Object,
      default: () => {},
    },
  },
  // emits: ['update:modelValue'],
  setup(props, { emit }) {
    const data = reactive({
      formRef: undefined,
      formData: ref<any>({
        status: props.row.status,
        paymentStatus: Number(props.row.isPayment),
      }),
      rules: {
        status: [required],
        paymentStatus: [required],
      },
      visible: false,
      titlename: '修正 ' + props.row.carId + ' 违章处理状态',
    })

    watchEffect(() => {
      data.visible = props.modelValue
    })

    /**
     * @description: 关闭dialog
     * @param {*} void
     * @return {*}
     */
    const onCancel = (): void => {
      data.visible = false
      emit('update:modelValue', false)
    }
    const handleClose = () => {
      onCancel()
    }

    const handleSubmit = async () => {
      const params = {
        id: props.row.id,
        status: data.formData.status,
        paymentStatus: data.formData.paymentStatus,
      }
      const [err] = await toResult(editDisposeStatus(params))
      if (err) return
      ElMessage.success('修正处理状态成功')
      onCancel()
    }

    onMounted(() => {
      console.log(props.row)
    })
    return {
      ...toRefs(data),
      onCancel,
      handleSubmit,
      handleClose,
    }
  },
})
